import React from 'react';
import { useTranslation } from 'react-i18next';
import useActionLabel from '../i18n/useActionLabel';
import CreditNoteEntryPanel from '../components/Procurement/CreditNoteEntryPanel';
import { Emo } from './EmojiIcons';
import DrawerHeader from './drawer/DrawerHeader';

// fb-143: supplier credit note in the global + Create drawer (the Purchasing + Data Entry > Add Credit Note
// used a local panel). Hosts the proven CreditNoteEntryPanel/CreditNoteForm; contextual entry points pass
// params {partner_id, operationId, mode}: a supplier page locks the supplier, an order page locks supplier+order.
export default function CreditNoteCreateForm({ size, onSize, onClose, onInteract, params }) {
  const { t } = useTranslation('dataEntry');
  const al = useActionLabel();
  const p = params || {};
  return (
    <>
      <DrawerHeader eyebrow={t('dataEntry:fl.purchases_credit_note')} ini={<Emo name="invoice" />} title={<>{al('recordSupplierCreditNote')}</>} size={size} onSize={onSize} onClose={onClose} />
      <div className="dr-body" onChange={onInteract}>
        <CreditNoteEntryPanel open embedded onClose={onClose} onSuccess={() => { window.dispatchEvent(new Event('supplier-money-changed')); if (onInteract) onInteract(false); onClose(); }}
          initialPartnerId={p.partner_id || ''} initialOperationId={p.operationId || ''}
          initialMode={p.mode || 'apply_to_goods'} lockPartner={!!p.partner_id} lockOrder={!!p.operationId} />
      </div>
    </>
  );
}
